export var BalancePlatformPayoutType;
(function (BalancePlatformPayoutType) {
    BalancePlatformPayoutType["Capture"] = "capture";
    BalancePlatformPayoutType["Chargeback"] = "chargeback";
    BalancePlatformPayoutType["BankTransfer"] = "bankTransfer";
    BalancePlatformPayoutType["Refund"] = "refund";
})(BalancePlatformPayoutType || (BalancePlatformPayoutType = {}));
//# sourceMappingURL=BalancePlatformPayoutType.js.map